import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useInView } from 'framer-motion';
import ourTechImg from "../../assets/Tech-Img.jpg"

const FooterBoxes = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  const fadeIn = {
    hidden: { opacity: 0 }, // Start with opacity 0
    visible: { opacity: 1, transition: { duration: 2.5 } }, // Fade to opacity 1
  };

  return (
    <section className="padding w-full py-12 bg-gray-100 bg-cover bg-center relative">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('${ourTechImg}')`,
        }}
      ></div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-40"></div>

      <div className="container mx-auto text-center mb-8 relative z-10">
        <h2 className="text-4xl font-bold text-white mb-4">
          What Makes <span className="text-blue-400">Our Academy</span>{" "}
          Different
        </h2>
        <p className="text-lg text-white mb-8">
          We believe in providing quality education to our students. Our team of
          experienced and knowledgeable teachers is dedicated to helping
          students succeed. Our focus is not just on academic excellence but
          also on the holistic development of our students.
        </p>

        <motion.div
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={{
            visible: { transition: { staggerChildren: 0.2 } },
          }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {/* Experience */}
          <motion.div
            variants={fadeIn}
            className="footer-box bg-gray-300 p-6 rounded-lg shadow-lg transition-all duration-300 transform hover:bg-gray-50 hover:shadow-xl hover:scale-105"
          >
            <h3 className="text-3xl font-bold text-blue-600 mb-2">5+</h3>
            <p className="text-gray-600">Years Experience</p>
          </motion.div>

          {/* Happy Students */}
          <motion.div
            variants={fadeIn}
            className="footer-box bg-gray-300 p-6 rounded-lg shadow-lg transition-all duration-300 transform hover:bg-gray-50 hover:shadow-xl hover:scale-105"
          >
            <h3 className="text-3xl font-bold text-blue-600 mb-2">2,250+</h3>
            <p className="text-gray-600">Happy Students</p>
          </motion.div>

          {/* Certified Teachers */}
          <motion.div
            variants={fadeIn}
            className="footer-box bg-gray-300 p-6 rounded-lg shadow-lg transition-all duration-300 transform hover:bg-gray-50 hover:shadow-xl hover:scale-105"
          >
            <h3 className="text-3xl font-bold text-blue-600 mb-2">30+</h3>
            <p className="text-gray-600">Certified Teachers</p>
          </motion.div>

          {/* Successful Batches */}
          <motion.div
            variants={fadeIn}
            className="footer-box bg-gray-300 p-6 rounded-lg shadow-lg transition-all duration-300 transform hover:bg-gray-50 hover:shadow-xl hover:scale-105"
          >
            <h3 className="text-3xl font-bold text-blue-600 mb-2">50+</h3>
            <p className="text-gray-600">Successful Batches</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default FooterBoxes;
